import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Components as SliderInputs } from './slider.style';
import Input from '../Input/Input';
import { forwardRef, useEffect, useState } from 'react';
import MultiSlider from './MultiSlider';
const Slider = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'slider',
      listData,
      onChange,
      max = 100,
      id = 'sliderId',
      min = 0,
      error,
      fit = 'medium',
      disabled,
      value = '0',
      variant = 'default',
      label,
      scrollThumb = false,
      hideValues = false
    } = props,
    rest = __rest(props, ["className", "listData", "onChange", "max", "id", "min", "error", "fit", "disabled", "value", "variant", "label", "scrollThumb", "hideValues"]);
  // slider local state variables declaration and hooks section
  const [optionsList, setOptionsList] = useState([]);
  const [inputNumberVal, setInputNumberval] = useState('' + value);
  const onInputNumberChange = e => {
    const tempSliderValue = e.target.value;
    setInputNumberval(tempSliderValue);
    setStyleToThumb(Number(tempSliderValue), max, id);
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };
  const setStyleToThumb = (value, max, id) => {
    if (variant !== 'multi') {
      const progress = (value - min) / (max - min) * 100;
      const sliderEle = document.querySelector("#".concat(id));
      const color = disabled ? '#CFCFCF' : '#42B0D5';
      sliderEle.style.background = "linear-gradient(to right, ".concat(color, " ").concat(progress, "%, #EDEDED ").concat(progress, "%)");
      if (scrollThumb) {
        sliderEle.style.height = 0;
      }
      sliderEle.style.setProperty('--thumb-rotate', "".concat(value / 100 * 2160, "deg"));
    }
  };
  useEffect(() => {
    setStyleToThumb(Number(inputNumberVal), max, id);
  }, [error, disabled]);
  useEffect(() => {
    if (listData === null || listData === void 0 ? void 0 : listData.length) {
      const datalistOptions = [];
      listData === null || listData === void 0 ? void 0 : listData.forEach((ele, index) => {
        datalistOptions.push([_jsx("option", _extends({
          value: ele
        }, {
          children: ele
        }), index)]);
      });
      setOptionsList(datalistOptions);
    }
  }, [listData]);
  return variant === 'multi' ? _jsx(MultiSlider, _extends({}, rest, {
    error: error,
    label: label,
    disabled: disabled,
    className: className,
    fit: fit,
    min: min,
    max: max,
    id: id,
    onChange: onChange,
    hideMultiSliderValues: hideValues
  })) : _jsxs(SliderInputs.RangeSlider, _extends({
    className: "".concat(className, "-wrapper"),
    fit: fit
  }, {
    children: [_jsxs(SliderInputs.SliderInput, _extends({
      fit: fit,
      disabled: disabled,
      listData: props.listData
    }, {
      children: [_jsx(Input, _extends({}, rest, {
        ref: ref,
        onChange: onInputNumberChange,
        value: inputNumberVal,
        type: "range",
        list: (listData === null || listData === void 0 ? void 0 : listData.length) ? "".concat(id, "-tickmarks") : undefined,
        className: className,
        id: id,
        min: min,
        max: max,
        error: error,
        disabled: disabled,
        fit: fit,
        variant: "default",
        label: label
      })), !(listData === null || listData === void 0 ? void 0 : listData.length) && !hideValues && inputNumberVal]
    })), (props === null || props === void 0 ? void 0 : props.listData) && !hideValues && _jsx("datalist", _extends({
      id: "".concat(id, "-tickmarks"),
      className: "sliderticks"
    }, {
      children: optionsList
    }))]
  }));
});
export default Slider;